export const Admin = {
  tabLabel1: 'Novo Utilizador'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/Admin.js